import { render, staticRenderFns } from "./SicavAsymetrix.vue?vue&type=template&id=a2d677e2&"
import script from "./SicavAsymetrix.vue?vue&type=script&lang=js&"
export * from "./SicavAsymetrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports